<template>
  <section id="section5">
    <h1>{{content['5.titel']}}</h1>
    <router-link to="/faq">
      <h3>{{ content['5.4.meerweten'] }}</h3>
    </router-link>
    <div v-for="index in 3" :key="index" class="box">
      <div class="question">{{content[`5.${index}.vraag`]}}</div>
      <div class="answer">{{content[`5.${index}.antwoord`]}}</div>
    </div>
  </section>
</template>

<script>
import content from '@/content/website.json'

export default {
  name: 'Section5',
  data () {
    return {
      content
    }
  }
}
</script>

<style scoped lang="scss">
#section5 {
  margin: 12rem auto;
  max-width: 99.2rem;

  h1, h3 {
    text-align: center;
  }

  h3 {
    margin-bottom: 3rem;
    text-decoration: underline;
    color: $color-black;
    transition: color 100ms;

    &:hover {
      color: $color-orange;
    }
  }
}

.box {
  margin-bottom: 1.5rem;
  padding: 3rem;
  color: $color-white;

  &:nth-of-type(1) { background-color: $color-green; }
  &:nth-of-type(2) { background-color: $color-blue; }
  &:nth-of-type(3) { background-color: $color-orange; }
}

.question {
  margin-bottom: 1.5rem;
  font-size: 2.4rem;
  font-weight: 700;
}

.answer {
  font-size: 1.8rem;
}
</style>
